import notify from "@/lib/notifications";

// intercepts responses to show error messages
const responseInterceptor = response => {
  if (response.status > 200) {
    notify.warn(
      "Oops! somethings not right!",
      response.data.detail ? response.data.detail : "Data Not Found"
    );
  }
  return response;
};

export default responseInterceptor;
